// Generated using typescript-generator version 1.25.322 on 2018-01-03 10:31:26.

export const DefaultPoolName: String = 'default';

export class ApiConfig {
  apiName: string;
  poolName: string;
  url: string;
  responseType: string;
  requestType: string;
  charsetType?: string;
  method: string;
  elementValidation: string;
  baseElement: string;
  name?: string;
  headers: any;

  constructor() {}
}

export class PoolConfig {
  maxTotalConnections: number;
  maxPerRoute: number;
  connectTimeout: number;
  readTimeout: number;
  maxIdleTime: number;
  connectionTtl: number;
  cleanerPeriod: number;
}


export class Channel {
  config: ChannelConfig;
  routes: { [index: string]: Route };
}

export class ChannelConfig {
  channelId: number; // being referenced as ['channel-id'] in project
  channelName: string;
  sessionLength: number;
  requireOptIn?: boolean;
  canResume: boolean;
  resumeMessage: string;
  resumeGracePeriod: number;
  propertyLayout: { [index: string]: any };
  keywordConflictMessage: string;
}

export class Route {
  flowName: string;
  start: string;
  clientId: number;
  isApiTokenCopied?: boolean;
  isApiUrlCopied?: boolean;
  isApiRegenerating ? = false;
  originalRouteId?: string;
  currRouteId?: string;
  routeId?: string;
  legacyClientId?: number;
  properties: { [index: string]: any };
  entityType: EntityTypes;
  entityId: any;
  serviceType?: string;
  flowService?: string;
  providerType?: string;
}

export class MenuTouch {
  businessHours: string;
  noAgentMessage: string;
  touchOptions: TouchOptions;
  apiToken: string;
}

export type TouchOptions = 'bot' | 'agent' | 'both';

export type EntityTypes = 'SYSTEM' | 'CLIENT' | 'VENDOR' | 'FUNDING_SOURCE' | 'CRM'  | 'TEMPLATE';

export interface LocationMessage {
  locationName: string;
  locationAddress: string;
  latitude: string;
  longitude: string;
}

export interface InteractiveMessage {
  title: string;
  replyMessage: string;
  message?: string;
  postbackData: string;
  messageDisplay: string;
  type: any;
  relatedClientMessageId?: string;
}

export interface LookupMediaData {
  src: string;
  name: string;
  type: string;
  size: string;
}


export interface Step {
  startStep?: string;
  flowName?: string;
  menu?: Menu;
  action?: Action;
  integration?: Integration;
  type: StateType;
  next: string;
  metadata?: { [index: string]: any };
}

export interface newStep {
  type: StateType;
}

export interface Action {
  name: string;
  description: string;
  text: string;
  linkMessage: string;
  actionType: string; // not sure why Its A string ?? and not ActionType
  actionParams: { [index: string]: any };
  result: { [index: string]: string };
}

export interface Menu {
  name: string;
  displayed: boolean;
  text: string;
  menuHeader: string;
  cancel: MenuCancel;
  input: MenuInput;
  replaceText: { [index: string]: string };
  flowId: string;
  next: string;
  options?: MenuOptions;
  url: string;
  results: { [index: string]: MenuResult };
  touch: Touch;
  payment: MenuPayments;
  menuType: menuTypes;
  datePickerMenu: DatePickerMenu;
  menuParams: { [index: string]: string };
  groups?: { [index: string]: MenuGroup };
  actionParams: { [index: string]: string };
}

export interface Integration {
  integrationType: string;
  name: string;
  description: string;
  endNode: EndNode;
}

export interface EndNode {
  endNodeType: string;
  outputVars: Object;
}

export interface MenuResult {
  next: string;
  description: string;
}

export interface MenuCancel {
  cancelInput: string;
  cancelMessage: string;
}

export interface MenuInput {
  varName: string;
  validationPattern: string;
  isPrivateVariable: boolean;
}

export interface MenuOptions {
  optionSeparator: string;
  items: { [index: string]: Menu };
  keywords: { [index: string]: Menu };
}

export interface MenuGroup {
  groupTitle: string;
  multipleSelection: boolean;
  items: { [index: string]: Menu };
}

export interface MenuPayments {
  linkText: string;
  cardText: string;
  operationType: PaymentType;
  amount: string;
  deleteCardConfirmationText: string;

  extension?: string;
  messageForLink?: string;
  currencyCode?: string;
  tax?: number;
  itemDescription?: string;
  autoReversePayment?: boolean;
  confirmationMessage?: string;
}

export interface Touch {
  apiToken: string;
  businessHours: string;
  noAgentMessage: string;
  successfullyConnectedMessage: string;
  touchOptions: string;
}

export interface DatePickerMenu {
  description: string;
  title: string;
  icon: string;
  variableName: string;
}
export type StateType = 'menu' | 'action' | 'new' | 'start';
export type PaymentType = 'payment' | 'management';
export type menuTypes = 'askInput' | 'displayMenu' | 'menuOption' | 'multipleChoice' | 'externalLink' | 'payment' | 'touch' | 'timePicker' | 'iMessage' | 'chat2pay' | 'menuForm';

export interface MapLocationData {
  id: string;
  address:string;
  mainAddress: string;
  secondaryAddress: string;
}

export interface LocationMessage {
  locationName: string;
  locationAddress: string;
  latitude: string;
  longitude: string;
}
